import { useRef, useState } from "react";
import { useTranslation } from "../../locale/useTranslation";
import HeaderRowAndSheetPopup from "../PartnerIngestion/SubComponents/HeaderRowAndSheetPopup";
import * as API from '../../framework/API/api';
import { Grid, GRID_COL_INDEX_ATTRIBUTE, GridColumn } from "@progress/kendo-react-grid";
import { DateTimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { Backdrop, Chip, CircularProgress, Typography } from "@mui/material";
import { EnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/EnumCell";
import ToastNotification from "../../components/ToastNotification";
import { TOAST_TYPES } from "../../framework/constant/constant";

const TrailerBooking = ({ onIngestComplete }) => {

  const lang = useTranslation();

  const [fileDataItem, setFileDataItem] = useState({ file: "" });
  const [files, setFiles] = useState([]);// to store selected file
  const fileRef = useRef(null); // to make ref null so that you can import same file again and again
  const [selectedExcelSheets, setSelectedExcelSheets] = useState([]);
  const [showHeaderRowSheetIndexPopup, setShowHeaderRowSheetIndexPopup] = useState(false);
  const [headerRowSheetIndex, setHeaderRowSheetIndex] = useState({ HeaderRowIndex: 1, SheetIndex: 0 });
  const [plannerGridData, setPlannerGridData] = useState([]);
  const [ingested, setIngested] = useState(false);
  const [ingestLoading, setIngestLoading] = useState(false);

  const uploadFilePathRef = useRef("");
  const downloadFilePathRef = useRef("");

  const isIngestDisabled = ingestLoading || ingested;


  const onIngest = async () => {
    if (ingestLoading) return; // prevent double clicks

    try {
      setIngestLoading(true);

      let ingestRes = await API.ingestForTrailerBooking(
        uploadFilePathRef.current,
        selectedExcelSheets[headerRowSheetIndex.SheetIndex]
      );

      if (ingestRes.success) {
        setPlannerGridData(
          ingestRes.data.map((item) => ({
            AssetId: item.AssetId,
            name: item.Title,
            from: item.StartDate,
            to: item.EndDate,
            duration: item.Duration,
            channels: item.Channels,
            genre: item.Genre,
            ingested: item.success
          }))
        );

        downloadFilePathRef.current = ingestRes.ingestedFilePath;
        setIngested(true);
        if (onIngestComplete) {
          onIngestComplete(ingestRes.data.filter(item => item.success));
        }
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: ingestRes.message });
      }
    } catch (err) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Ingestion failed. Backend probably sneezed." });
    } finally {
      setIngestLoading(false);
    }
  };


  const handleFileChange = async (e) => {
    setFileDataItem({ ...fileDataItem, [e.target.name]: e.target.value });
    setFiles(e.target.files[0]);

    //ON SELECT FILE SET DATA IN GRID

    let excelSheetsRes = await API.getExcelSheets(e.target.files[0]);
    if (excelSheetsRes.success && excelSheetsRes.data.length > 0) {
      setSelectedExcelSheets(excelSheetsRes.data);
    }
    setHeaderRowSheetIndex({ HeaderRowIndex: 1, SheetIndex: 0 });
    setShowHeaderRowSheetIndexPopup(true);


  };

  const getDataFromFile = async (files) => {
    // upload file
    let uploadFileResponse = await API.uploadFile(files);
    if (!uploadFileResponse.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to upload file" });
      return false;;
    }
    uploadFilePathRef.current = uploadFileResponse.data;
    let fileDataResponse = await API.getDataForTrailerBookingIngest(uploadFileResponse.data, selectedExcelSheets[headerRowSheetIndex.SheetIndex]);
    if (!fileDataResponse.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: fileDataResponse.message });
      return false;
    }
    return fileDataResponse.data;

  }

  const loadDataOnFileSelect = async (fileDataItem, files) => {

    if (!fileDataItem.file) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_file_first_error_message });
      return
    }


    let fileData = await getDataFromFile(files);
    if (!fileData) {
      setShowHeaderRowSheetIndexPopup(false);
      return;
    }

    setPlannerGridData(fileData)

    setShowHeaderRowSheetIndexPopup(false);

  }

  const handleOnHeaderRowSheetIndexConfirm = () => {
    loadDataOnFileSelect(fileDataItem, files);
  }

  const downloadExportReport = async () => {
    await API.downloadFile(downloadFilePathRef.current.toString().split('userFiles\\').pop());
  }

  const IngestionStatusCell = (props) => {

    let value = props.dataItem.ingested;

    let style = {
      ...props.style,
      backgroundColor: props.style.background,
    }

    let newStyle = {
      ...props.style,
      color: 'white', //green
      backgroundColor: value ? '#008000' : '#FF0000',
      display: "flex", textAlign: "center", alignItems: "center", justifyContent: "center",
      border: '0.05em solid #9a9c92', borderRadius: '4px',
      fontWeight: props.titleFontWeight ? props.titleFontWeight : "normal",
      fontSize: props.titleFontSize ? props.titleFontSize : "12px",
      verticalAlign: props.titleVerticalAlignment ? props.titleVerticalAlignment : "center",
      fontFamily: props.titleFontFamily ? props.titleFontFamily : "Roboto",
      letterSpacing: "0.6px",
    }

    return <td
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...{
        [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
      }}
      {...useTableKeyboardNavigation(props.id)}
      style={style}
    >
      {<span style={newStyle} id={props.dataItem?._id}>
        {value ? "Yes" : "No"}
      </span>}
    </td>;
  };

  return (
    <div style={{ height: "100%" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <input type="text" className="form-control form-control-sm" name="filename" value={fileDataItem.file ?? ""} disabled={true} style={{ width: "200px" }} />
          <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary" style={{ padding: '0px', height: "32px", margin: '0px 0px 0px 3px' }}>
            <label className="fa-solid fa-ellipsis-h" style={{ padding: '5px 9px', margin: '0px', cursor: 'pointer' }}>
              <input
                ref={fileRef}
                id="fileupload"
                name="file"
                className='custom-file-updated-input form-control form-control-sm'
                type="file"
                hidden="hidden"
                onClick={() => {
                  // empty the input value to allow re-uploading the same file
                  fileRef.current.value = null;
                }}
                onChange={handleFileChange}
                accept={".xlsx,.xls"}
              />
            </label>
          </button>
          <button
            title={
              ingested
                ? "Already ingested"
                : lang.ingest_button_tooltip
            }
            type="button"
            onClick={onIngest}
            className="btn-square btn-success"
            style={{ marginLeft: "10px", minWidth: "100px" }}
            disabled={isIngestDisabled}
          >
            {ingestLoading
              ? "Ingesting..."
              : ingested
                ? "Ingested"
                : lang.ingest_button_text}
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* ignested number / total numbers */}
          {plannerGridData.length > 0 && <span style={{ marginRight: "10px" }}>
            <Chip label={
              `${plannerGridData.filter(item => item.ingested).length} / ${plannerGridData.length} Ingested`
            } />
          </span>}
          {ingested && <RoundButton
            icon={"download"}
            btnColor={"info"}
            style={{ color: 'white' }}
            // iconColor={"white"}
            title={lang.export_button_tooltip}
            onClick={downloadExportReport}
          />}
        </div>
      </div>

      <div style={{ marginTop: "20px", height: "calc(100% - 110px)" }}>
        {ingestLoading && (
          <Backdrop
            open={ingestLoading}
            sx={{
              position: "absolute",
              zIndex: 10,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.25)"
            }}
          >
            <div style={{ textAlign: "center" }}>
              <CircularProgress color="inherit" />
              <Typography variant="subtitle2" sx={{ mt: 1 }}>
                Ingesting…
              </Typography>
            </div>
          </Backdrop>

        )}

        {/* Planner Grid to show data */}
        <Grid
          data={plannerGridData}
          resizable={true}
          style={{ height: "100%", minHeight: "450px" }}
        >
          {/* add hardcoded sno. */}
          <GridColumn title="Sno." width={"60px"} cell={(props) => <td>{props.dataIndex + 1}</td>} />
          <GridColumn field="ingested" title="Ingested" width={"120px"} cell={IngestionStatusCell} />
          <GridColumn field="AssetId" title="AssetId" width={"120px"} />
          <GridColumn field="name" title="Title" width={"220px"} />
          <GridColumn field="from" title="From" cell={DateTimeCell} width={"180px"} />
          <GridColumn field="to" title="To" cell={DateTimeCell} width={"180px"} />
          <GridColumn field="duration" title="Duration" cell={TimeCell} width={"120px"} />
          <GridColumn field="channels" title="Channels" />
          <GridColumn field="genre" title="Genre" width={"120px"} />
          <GridColumn field="frequencyType" title="Frequency Type" cell={EnumCell} width={"150px"} />
          <GridColumn field="frequencyValue" title="Frequency Value" width={"120px"} />

        </Grid>
      </div>
      {showHeaderRowSheetIndexPopup && <HeaderRowAndSheetPopup onConfirm={handleOnHeaderRowSheetIndexConfirm} onClose={() => { setShowHeaderRowSheetIndexPopup(false) }} sheets={selectedExcelSheets} setHeaderRowSheetIndex={setHeaderRowSheetIndex} showHeaderRow={false} />}
    </div>
  );
}

export default TrailerBooking;